/**
 * Palettes du grand format (portées de menu-grand-format.html : `.ed`, `.bd`).
 * Fichier pur (pas de JSX) — les couleurs sont FIXES, déconnectées du thème
 * cockpit puisque la feuille est la cible directe de `domToPng`.
 */

export interface LargePalette {
  background: string;
  color: string;
  rowLine: string;
  headColor: string;
  portraitBorder: string;
  ruleColor: string;
  sectionTitleColor: string;
  sectionTitleBorder: string;
  descColor: string;
  priceColor: string;
  footColor: string;
  /** Titre « {Pseudo} Menu » en capitales (Boudoir) ou non (Éditorial). */
  titleUppercase: boolean;
  /** Placeholder photo (carré). */
  portraitBg: string;
  portraitFg: string;
}

export const EDITORIAL_LARGE: LargePalette = {
  background: "#fbf9f4",
  color: "#17130d",
  rowLine: "#efe9dd",
  headColor: "#8a8073",
  portraitBorder: "#e4ddcf",
  ruleColor: "#161310",
  sectionTitleColor: "#161310",
  sectionTitleBorder: "#e0d8c8",
  descColor: "#8a8073",
  priceColor: "#161310",
  footColor: "#a99f8c",
  titleUppercase: false,
  portraitBg: "#efe9dd",
  portraitFg: "#cfc6b4",
};

export const BOUDOIR_LARGE: LargePalette = {
  background: "#141109",
  color: "#efe6d3",
  rowLine: "rgba(198,169,107,.14)",
  headColor: "#c6a96b",
  portraitBorder: "rgba(198,169,107,.3)",
  ruleColor: "rgba(198,169,107,.35)",
  sectionTitleColor: "#c6a96b",
  sectionTitleBorder: "rgba(198,169,107,.22)",
  descColor: "#998b68",
  priceColor: "#c6a96b",
  footColor: "#8b7f63",
  titleUppercase: true,
  portraitBg: "#241d10",
  portraitFg: "rgba(198,169,107,.5)",
};

// Pop grand : stub documenté — structure Éditorial/Boudoir + dégradé et texte
// blanc du Pop petit format (le fichier de référence n'a que ed + bd en grand).
export const POP_LARGE: LargePalette = {
  background: "linear-gradient(150deg, #ff69a8 0%, #c95ad0 48%, #7d54ff 100%)",
  color: "#ffffff",
  rowLine: "rgba(255,255,255,.18)",
  headColor: "rgba(255,255,255,.9)",
  portraitBorder: "rgba(255,255,255,.85)",
  ruleColor: "rgba(255,255,255,.4)",
  sectionTitleColor: "#ffffff",
  sectionTitleBorder: "rgba(255,255,255,.35)",
  descColor: "rgba(255,255,255,.85)",
  priceColor: "#ffffff",
  footColor: "rgba(255,255,255,.9)",
  titleUppercase: false,
  portraitBg: "#c95ad0",
  portraitFg: "rgba(255,255,255,.7)",
};
